import { Component, OnInit, ViewChild } from '@angular/core';
import { MessageService } from 'primeng/api';
import { TableModule } from 'primeng/table';
import { ToastModule } from 'primeng/toast';

import { TagModule } from 'primeng/tag';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { FormsModule } from '@angular/forms';
import { TableComponent } from '../components/table/table.component';
import { PayLoadData } from '../interfaces/CustomerCallRecords';
import { CustomerCallRecordsService } from '../../services/customer-call-records.service';
import { AllRecordsService } from '../../services/allRecordsService';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { environment } from '../../environments/environment';
import { MyMonitoringService } from '../../services/logging.service';
import { DialogModule } from 'primeng/dialog';
import { ActivatedRoute } from '@angular/router';
import { ERROR_MESSAGES } from '../common/constants';
import { Reports } from '../interfaces/Reports';
import * as XLSX from 'xlsx-js-style';
import { HttpClient } from '@angular/common/http';
import { Observable, of, switchMap, tap } from 'rxjs';
import { ApiService } from '../../services/apiservice';
import { SeverityLevel } from '@microsoft/applicationinsights-web';
@Component({
  selector: 'app-home',
  templateUrl: './customer-call-records.component.html',
  styleUrl: '../app.component.scss',
  standalone: true,

  imports: [DialogModule, TableModule, ToastModule, TagModule, ButtonModule, InputTextModule, FormsModule, TableComponent, ProgressSpinnerModule],
  providers: [MessageService, CustomerCallRecordsService, MyMonitoringService, AllRecordsService]
})
export class CustomerCallRecordsComponent implements OnInit {
  @ViewChild('tblConfig') tblConfig!: TableComponent;
  errorMessage: string = ERROR_MESSAGES.GENERIC_ERROR;

  router: any;
  param: any;
  formattedDate: string = "";
  processMessage: string = "";
  homeLoadDataColumns: any[] = [];
  Reports!: Reports[];
  NewReports!: Reports[];
  homeDataPayLoad$!: Observable<PayLoadData[]>;
  selectedItems: any[] = [];
  AppKeyValuePairs: any[] = [];
  actionButtons: any = [];
  isLoading: boolean = false;
  isSuccess: boolean = false;
  isFailure: boolean = false;
  pageSize: number = 10;
  totalRecords: number = 2000;
  currentPage: number = 1;
  dialogVisible: boolean = false;
  cellValue: any[] = ['', ''];
  commentTable: any[] = [];
  comments$!: Observable<any[]>;
  selectedRow: any;
  txtComment: any;
  user: any;
  sortField: string = "";
  sortOrder: number = 1;
  searchText: any = "";
  constructor(
    private route: ActivatedRoute,
    private http: HttpClient,
    private customerCallRecordsService: CustomerCallRecordsService,
    private messageService: MessageService,
    private monotoringService: MyMonitoringService,
    private allRecordsService: AllRecordsService,
    private apiService: ApiService) {
    this.router = route;
  }

  ngOnInit(): void {
    this.getCurrentDate();
    this.route.paramMap.subscribe(params => {
      this.param = params.get('tier');
      this.tblConfig.searchValue = this.param;
    });

    this.actionButtons = [
      { "id": "1", "title": "Download", "icons": "pi pi-download", "display": "block", "msg": "Are you sure that you want to download the data?" },
      { "id": "2", "title": "Reload", "icons": "pi pi-refresh", "display": "block" },

    ];
    this.LoadHeader();
    this.LoadDetails();
  }


  showDialog() {
    this.dialogVisible = true;
  }

  LoadHeader(): void {
    this.processMessage = environment.appMessages.loadingMesage;
    this.homeLoadDataColumns = [
      { "field": "OrderType", "header": "ORDER TYPE", "filter": true, "isSorting": true, "width": "5%" },
      { "field": "AnalystStatus", "header": "ANALYST STATUS", "filter": true, "isSorting": true, "width": "5%" },
      { "field": "Count", "header": "COUNT", "filter": true, "isSorting": true, "width": "5%" },
    ];
  }

  LoadDetails(): void {
    this.isLoading = true;
    this.processMessage = environment.appMessages.loadingMesage;
    this.apiService.groupId().pipe(
      switchMap(groupId => {
        const payload = {
          PageNumber: this.currentPage,
          PageSize: this.pageSize,
          UserId: sessionStorage.getItem('userId'),
          GroupID: groupId,
          SortField: this.sortField,
          SortOrder: this.sortOrder,
          SearchText: this.searchText
        };
        return this.customerCallRecordsService.getResult(payload);
      })
    ).subscribe({
      next: (data: any) => {
        const totalRec = data?.Payload?.TotalRecords;
        this.homeDataPayLoad$ = of(data?.Payload?.Data);
        this.isSuccess = true;
        this.totalRecords = totalRec;
        this.isLoading = false;
      },
      error: error => {
        this.isLoading = false;
        this.isFailure = true;
        const errMsg = environment.appMessages.ServerError;
        this.messageService.add({ severity: 'error', summary: 'Failed', detail: errMsg });
        this.monotoringService.logException({ name: 'CustomerCallRecordsComponent.LoadDetails', message: error }, SeverityLevel.Error);
      },
      complete: () => {
        this.isLoading = false;
      }
    });
  }

  onSearchText(event: any): void {
    this.processMessage = environment.appMessages.loadingMesage;
    this.isLoading = true;
    this.currentPage = 1;
    this.tblConfig.resetPage();
    this.searchText = event.searchText;
    this.LoadDetails();
  }

  onSortClicked(event: any): void {
    this.sortField = event.sortField;
    this.sortOrder = event.sortOrder;
    this.processMessage = environment.appMessages.loadingMesage;
    this.isLoading = true;
    this.LoadDetails();
  }

  summaryCountRefresh() {
    this.LoadHeader();
    this.LoadDetails();
    this.getCurrentDate();
  }
  exportExcel(): void {
    this.apiService.groupId().pipe(
      switchMap(groupId => this.allRecordsService.getReport(groupId))
    ).subscribe({
      next: (data: any) => {
        this.Reports = data?.Payload;
        const NewReports = this.Reports.map(rec => {
          return {
            'SAP WO': rec.SapWo,
            'TYPE': rec.Type,
            'DATE TAKEN': rec.DateTaken,
            'DISTRICT': rec.District,
            'SCHED DATE': rec.SchedDate,
            'ANALYST STATUS': rec.AnalystStatus,
            'IN SAP': rec.InSap,
            'DISPATCH STATUS': rec.DispatchStatus,
            'TAKEN BY': rec.TakenBy,
            'LAST': rec.Last,
            'FIRST': rec.First,
            'HOUSE': rec.House,
            'STREET': rec.street,
            'City': rec.City,
            'STATE': rec.State,
            'ZIP': rec.Zip,
            'TECH FIRST': rec.TechFirst,
            'TECH LAST': rec.TechLast,
            'TECH ID': rec.TechId,
            'STATUS UPDATE NOTES': rec.StatusUpdateNotes
          }
        });
        const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(NewReports);
        const workbook: XLSX.WorkBook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, ws, 'Reports');
        XLSX.writeFile(workbook, `Reports.xlsx`);
      },
      error: error => {
        this.isLoading = false;
        this.isFailure = true;
        const errMsg = environment.appMessages.ServerError;
        this.messageService.add({ severity: 'error', summary: 'Failed', detail: errMsg });
        this.monotoringService.logException({ name: 'CustomerCallRecordsComponent.exportExcel', message: error }, SeverityLevel.Error);
      },
      complete: () => {
        this.isLoading = false;
      }
    });
  }

  getCurrentDate() {
    const now = new Date();
    this.formattedDate = now.toLocaleString('en-US', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: true
    });
  }

  onPageChanged(event: any): void {
    const pageSize = event.pageSize;
    const pageNumber = event.page;
    this.currentPage = pageNumber;
    this.pageSize = pageSize;
    this.LoadDetails();
  }
}
